import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ProductListSaleSelect from '../sale_select';
import ProductListFilterSortWrapper from '../filter_sort_wrapper';
import ProductListDesktopFilter from './filter';
import { SHOPPING_CATEGORY_COLLECTIONS } from '../../../../constants';
import i18nMessages from '../__i18n__';
import { injectIntl } from 'react-intl';
import Link from 'react-router/lib/Link';
import { FaIcon } from '../../../common/fa_icons';
import RosettaFormattedMessage from '../../../common/rosetta_formatted_message';

const SHOPPING_COLLECTION_DROPDOWN_LABEL = 'Collections';

export class ProductListDesktopFilterBar extends Component {

  render() {
    const messages = i18nMessages();

    const { intl, handleFilter, handleSaleToggle, handlePriceFilter,
      handleSort, on_sale, sort, categoryFilter, subcategoryFilter, filterSortHidden,
      handleFilterAndSortUpdate, toggleFilterAndSort, handleFilterAndSortClear,
      classFilter, shoppingNavigationItems,
      productList: { categoryType, isBrandOrRetailerPage },
      selectedPriceRange
    } = this.props;

    const { categories, subcategories, classes } = shoppingNavigationItems;

    let firstDropDownFilter;
    if (isBrandOrRetailerPage) {
      firstDropDownFilter = (<ProductListDesktopFilter
        label={intl.formatMessage(messages.department)}
        dropdownItems={categories.filter(
          category => category.name !== SHOPPING_COLLECTION_DROPDOWN_LABEL
        )}
        handleFilter={handleFilter}
        filter={categoryFilter}
        filterSortHidden={filterSortHidden}
        toggleFilterAndSort={toggleFilterAndSort}
                             />); // eslint-disable-line indent
    }

    let subcategoryDesktopFilter;
    if (subcategories.length > 0 && (categoryType !== SHOPPING_CATEGORY_COLLECTIONS)) {
      subcategoryDesktopFilter = (<ProductListDesktopFilter
        label={intl.formatMessage(messages.category)}
        dropdownItems={subcategories}
        handleFilter={handleFilter}
        filter={subcategoryFilter}
        filterSortHidden={filterSortHidden}
        toggleFilterAndSort={toggleFilterAndSort}
                                  />); // eslint-disable-line indent
    }

    let classDesktopFilter;
    if (subcategoryFilter && classes.length > 0) {
      classDesktopFilter = (
        <ProductListDesktopFilter
          label={intl.formatMessage(messages.type)}
          dropdownItems={classes}
          handleFilter={handleFilter}
          filter={classFilter}
          filterSortHidden={filterSortHidden}
          toggleFilterAndSort={toggleFilterAndSort}
        />
      );
    }

    let viewAllCollectionsLink;
    if ((categoryType === SHOPPING_CATEGORY_COLLECTIONS)) {
      viewAllCollectionsLink = (
        <Link className="all-collections-link" to="/en-us/shop/collections">
          <RosettaFormattedMessage parentFilename={__filename}
            id="view_all_collections"
            description="View All Collections Link in filter bar"
            defaultMessage="View All Collections"
          />
          <FaIcon iconName="chevron-right" tagName="span" />
        </Link>
      );
    }

    return (
      <div className="filter-bar">
        {viewAllCollectionsLink}
        {firstDropDownFilter}
        {subcategoryDesktopFilter}
        {classDesktopFilter}
        <ProductListFilterSortWrapper
          filterSortHidden={filterSortHidden}
          handleFilterSortClick={toggleFilterAndSort}
          handleFilterAndSortUpdate={handleFilterAndSortUpdate}
          handleFilterAndSortClear={handleFilterAndSortClear}
          handlePriceFilter={handlePriceFilter}
          handleSort={handleSort}
          shoppingNavigationItems={shoppingNavigationItems}
          selectedPriceRange={selectedPriceRange}
          sort={sort}
        />
        <ProductListSaleSelect on_sale={on_sale}
          handleSaleToggle={handleSaleToggle}
        />
      </div>
    );
  }
}

ProductListDesktopFilterBar.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }),
  api: PropTypes.object.isRequired,
  handleFilterAndSortUpdate: PropTypes.func.isRequired,
  handleFilter: PropTypes.func.isRequired,
  handleSaleToggle: PropTypes.func.isRequired,
  shoppingNavigationItems: PropTypes.shape({
    subcategories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      name: PropTypes.string
    })),
    classes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      name: PropTypes.string
    }))
  }).isRequired,
  productList: PropTypes.shape({
    categoryType: PropTypes.string,
    isBrandOrRetailerPage: PropTypes.bool
  }).isRequired,
  on_sale: PropTypes.string,
  categoryFilter: PropTypes.string,
  subcategoryFilter: PropTypes.string,
  classFilter: PropTypes.string,
  handlePriceFilter: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  sort: PropTypes.string,
  filterSortHidden: PropTypes.bool,
  toggleFilterAndSort: PropTypes.func,
  handleFilterAndSortClear: PropTypes.func.isRequired,
  selectedPriceRange: PropTypes.object
};

export default injectIntl(ProductListDesktopFilterBar);
